import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY } from "@faire/web-api--source/indigofair/settings/LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSetting } from "@faire/web/common/settings/__internal__/useSetting";

export const getSettingOpenWithFaireAvailableForCountry = (): boolean =>
  getSettingValueWithoutAssignment(
    LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY,
    false
  );

export const useSettingOpenWithFaireAvailableForCountry = (): boolean =>
  useSetting(LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY, false);
